import { render, staticRenderFns } from "./privacySettings.vue?vue&type=template&id=cc725ecc&scoped=true&"
import script from "./privacySettings.vue?vue&type=script&lang=js&"
export * from "./privacySettings.vue?vue&type=script&lang=js&"
import style0 from "./privacySettings.vue?vue&type=style&index=0&id=cc725ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc725ecc",
  null
  
)

export default component.exports